import useKitchenGroups from './useKitchenGroups';

export default useKitchenGroups;
